<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <ul
      style="display: flex;
    width: 100%;
    justify-content: end"
      class="list-unstyled topnav-menu list-menu-header mb-0"
    >
      <li
        v-if="loggedIn && environment === 'PRODUCTION'"
        class="d-block d-sm-none"
        right
      >
        <div class="nav-link mr-0 waves-effect waves-light">
          <Network v-slot="status">
            <b-button
              v-b-popover.hover.bottomleft="
                `${status.isOnline ? 'En línea' : 'Desconectado'}. 
                      ${
                        status.downlink > 4
                          ? 'Recepción excelente'
                          : status.downlink >= 1.3
                          ? 'Recepción buena'
                          : status.downlink >= 0.3
                          ? 'Recepción aceptable'
                          : status.isOnline
                          ? 'Recepción pobre'
                          : 'Modo offline'
                      }`
              "
              variant="transparent"
            >
              <b-icon-wifi-off
                v-if="status.downlink < 0.3 || status.isOnline === false"
                variant="danger"
                font-scale="2.5"
              />
              <b-icon-wifi
                v-else-if="status.downlink > 4"
                variant="success"
                font-scale="2.5"
              />
              <b-icon-wifi2
                v-else-if="status.downlink >= 1.3"
                variant="success"
                font-scale="2.5"
              />
              <b-icon-wifi1
                v-else-if="status.downlink >= 0.3"
                variant="warning"
                font-scale="2.5"
              />
            </b-button>
          </Network>
        </div>
      </li>
      <div
        class=" m-0 px-0 waves-effect float-right waves-light nav-menu-sesion"
        style="line-height: 20px;z-index: 9999; padding-right: 24.5px !important; top: -10px;position: relative;"
      >
        <li v-if="loggedIn" right class="btn-toggle-right ">
          <button
            class="btn btn-link right-bar-toggle waves-effect waves-light p-0 m-0"
            @click="toggleRightSidebar"
          >
            <b-icon-list class="icon-toggle " variant="info" font-scale="2.8" />
          </button>
        </li>
      </div>
      <!-- <li class="dropdown notification-list">
        <button
          class="btn btn-link nav-link right-bar-toggle waves-effect waves-light btn-menu-toggle"
          @click="toggleMenu"
        >
          <b-icon-list variant="info" font-scale="2.1" class="mt-2" />
        </button>
      </li> -->
    </ul>

    <!-- LOGO -->

    <div class="texto-box" @click.prevent="reloadHome"
    >
      <span class="text-info-compañy-header d-flex justify-content-start"
      :class="{
              'no-visible-mobile': '/home' == $route.path
                ? true
                : false,
            }">
        <span class="d-none d-lg-block d-sm-none d-md-none">Secretaría de Innovación Digital - Caracterización 360</span>
        <span class="d-sm-block d-md-block d-lg-none">Caracterización 360</span>
      </span>
      <span class="d-flex align-self-end justify-content-end navUserLabel name-user" :class="{
              'visible-mobile': '/home' !== $route.path
                ? true
                : false,
            }">
        Hola,
        <strong class="margin-left-nav">
          {{
            currentSession ? currentSession.user.first_name
              ? currentSession.user.first_name
              : currentSession.user.username
              : ''
          }}
          {{
            currentSession ? currentSession.user.last_name ? currentSession.user.last_name : '' : ''
          }}
        </strong>

        <!-- <i class="mdi mdi-chevron-down"></i> -->
      </span>
    </div>
  </div>

  <!-- end Topbar -->
</template>

<script>
import { authComputed } from '@state/helpers'
import Network from '@plugins/Network'
import handleObject from '@utils/handle-objects'

// import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: { Network },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    toggleMenu: {
      type: Function,
      required: false,
      default: () => {},
    },
    toggleRightSidebar: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      environment: process.env.ENVIRONMENT,
    }
  },
  computed: {
    ...authComputed,
    getCompanyInfo: function() {
      let ConpanyInfo = this.$store.state.appAuth.companyInfo || null
      return ConpanyInfo || null
    },
    getMediaUrl: function() {
      return ''
    },
  },
  methods: {
    reloadHome() {
      const me = this;
      if (me.$route.path == "/home") {
        window.location.reload();
      } else {
        me.$router.push("/home")
      }
    }
  },
}
</script>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
.icon-toggle {
  margin-top: 58%;
}
.list-menu-header {
  position: absolute;
}
.text-info-compañy-header {
  font-size: 14px;
}
.name-user {
  font-size: 10px;
}
.margin-left-nav {
  margin-left: 3px;
}
</style>
